const useTextTools = () => {
  const truncate = (text, maxWords, placeholder = "...") => {
    const splitText = text.split(" ");

    return splitText?.length > maxWords
      ? `${splitText.slice(0, maxWords).join(" ")} ${placeholder}`
      : splitText.join(" ");
  };

  return {truncate};
};

export default useTextTools;
